import { Box, Divider, Grid2 } from "@mui/material";
import BabySizeImage from "./BabySizeImage";
import BabySizeText from "./BabySizeText";
import { useEffect, useRef } from "react";
import styles from "./BabyImagesTimeline.module.scss";
import { ImageTheme } from "../../utility/interfaces/babyWeekImageDataInterface";

interface BabyImagesByWeekProps {
  babyweekData: ImageTheme;
  currentWeek: number;
}

const BabyImagesByWeek: React.FC<BabyImagesByWeekProps> = ({
  babyweekData,
  currentWeek,
}) => {
  const currentWeekRef = useRef<HTMLDivElement | null>(null);

  // Cap the badge week at 40
  const effectiveWeek = currentWeek > 40 ? 40 : currentWeek;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (currentWeekRef.current) {
        currentWeekRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className={styles.wrapper}>
      <Divider
        orientation="vertical"
        className={styles.verticalDivider}
      />

      {babyweekData.patientImageWeekInfo.map((item, index) => {
        const isLeft = index % 2 === 0;
        const showBadge = item.pregnancyWeekId === effectiveWeek;

        return (
          <Grid2
            container
            key={item.weekImageThemeMappingId}
            className={styles.timelineRow}
            justifyContent="space-between"
            alignItems="center"
            ref={showBadge ? currentWeekRef : null}
          >
            {isLeft ? (
              <>
                <Grid2
                  size={{ xs: 6, sm: 5 }}
                  display="flex"
                  justifyContent="flex-end"
                  sx={{ pr: 2 }}
                >
                  <BabySizeImage
                    src={item.imagePath}
                    alt={item.imageText}
                  />
                </Grid2>

                <Box className={styles.halfLineLeft} />

                <Grid2
                  size={{ xs: 6, sm: 5 }}
                  sx={{ pl: 2 }}
                >
                  <BabySizeText
                    title={item.pregnancyWeekDisplayName}
                    message={item.imageText}
                    description={item.weekLongDescription}
                    align="left"
                    showHereBadge={showBadge}
                  />
                </Grid2>
              </>
            ) : (
              <>
                <Grid2
                  size={{ xs: 6, sm: 5 }}
                  sx={{ pr: 2 }}
                >
                  <BabySizeText
                    title={item.pregnancyWeekDisplayName}
                    message={item.imageText}
                    description={item.weekLongDescription}
                    align="right"
                    showHereBadge={showBadge}
                  />
                </Grid2>

                <Box className={styles.halfLineRight} />

                <Grid2
                  size={{ xs: 6, sm: 5 }}
                  display="flex"
                  justifyContent="flex-start"
                  sx={{ pl: 2 }}
                >
                  <BabySizeImage
                    src={item.imagePath}
                    alt={item.imageText}
                  />
                </Grid2>
              </>
            )}
          </Grid2>
        );
      })}
    </Box>
  );
};

export default BabyImagesByWeek;
